// src/firebase/FirebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBjUUYMwrYRtrNynBCep9shu9huofBu06g",
    authDomain: "tour-3c726.firebaseapp.com",
    projectId: "tour-3c726",
    storageBucket: "tour-3c726.appspot.com",
    messagingSenderId: "214596749515",
    appId: "1:214596749515:web:289293bf69c02ea054334e"
};

const app = initializeApp(firebaseConfig);

export const fireDB = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app); 
